// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class UnwindEvent extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** String */
  afterSnapshot?: string;
  /** Decimal */
  amount?: number;
  /** String */
  beforeSnapshot?: string;
  /** String */
  correlationChildIds?: string;
  /** Guid */
  correlationId!: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(64) */
  crtnUserInit!: string;
  /** String(64) */
  eventType!: string;
  /** String(1000) */
  failureReason?: string;
  /** String(200) */
  idempotencyKey!: string;
  /** String(1000) */
  notes?: string;
  /** String(20) */
  outcome!: string;
  /** Guid */
  relatedForeignEventId?: string;
  /** String(64) */
  sourceEntityId!: string;
  /** String(64) */
  sourceEntityType!: string;
  /** Guid */
  sourceSupplierId?: string;
  /** String(16) */
  sourceSystem!: string;
  /** String(64) */
  stepName!: string;
}

